import React from 'react'

export default function MediaWarning({close}) {
  return (
    <div>
        <div>
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center" style={{maxWidth: '90%', width: '1000px'}}>
                    <h4>⚠️ Regenerating Posts Warning</h4>

                    <div style={{textAlign: 'left'}}>
                        Changing the uploaded media files will trigger a full regeneration of all posts.
                        Any existing edits or customizations you’ve made — including titles, content, media attachments, and owner assignments — will be permanently lost.

                        Are you sure you want to continue?
                    </div>

                    <div className="pt-3">
                        <button onClick={() => window.location = '/group/post/media'} type="button" className="btn btn-primary mr-2">
                            Proceed
                        </button>

                        <button onClick={close} type="button" className="btn btn-secondary mr-2">
                            Close
                        </button>
                    </div>
                </div>
            </div>  
        </div>
    </div>
  )
}
